import Guide1 from "../../images/guide/business-license-image-1.png"
import Guide2 from "../../images/guide/business-license-image-2.png"

import {useState} from "react";
import Button from "../Button";

const AdvanceGuide = ({onFinish}) => {
    const [activeSlideIndex, setActiveSlideIndex] = useState(0)
    const slides = [
        {
            title: <span><span className="text-green-500">بازدید کننده‌های</span> آگهی خودت رو،<br/> تبدیل به <span className="text-green-500">مشتری</span>  کن</span>,
            subTitle:<span>تاییدیه مجوز کسب و کار</span>,
            image: Guide1,
        },
        {
            subTitle:<span>افزایش تعداد تماس‌ها و چت‌ها</span>,
            title:<span>به بازدید کننده‌ها نشون بده چه <span className="text-green-500 ">مجوزها و پروانه‌هایی</span> داری و <span className="text-green-500">اعتمادشون</span> رو در یک نگاه جلب کن.</span>,
            image: Guide2,
        }

    ];
    const handleNext=()=>{
        if(activeSlideIndex<slides.length-1){
            setActiveSlideIndex(activeSlideIndex+1)
        }else {
            onFinish()
        }
    }
    const handlePrev=()=>{
        if(activeSlideIndex!==0){
            setActiveSlideIndex(activeSlideIndex-1)
        }
    }
    return <div className="advance-guide">
        <div>
            {slides.map((item,index)=><div className={`flex flex-col items-center justify-center ${activeSlideIndex===index ? '':'hidden'}`}>
                <p className={`advance-title `} >{item.title}</p>
                <p  className=" font-bold mt-2 pt-2 border-t-2  " >{item.subTitle}</p>
            </div>)}
            <div className="mt-2">
                {slides.map((item, index) => {
                    return <div key={'image-'+index} className={`advance-slide ${index === activeSlideIndex ? 'active' : ''}`}>

                        <img className='advance-slide-image' src={item.image} alt=""/>
                    </div>
                })}
            </div>

        </div>
        <div className="w-full lg:w-6/12 mx-auto xl:w-3/12   bottom-0 py-2  fixed   z-20">
            <div className="w-full  flex col-span-2 mb-3  justify-center items-center">
                {slides.map((item,index)=><div key={index+'-dot'} className={`advance-slide-dot ${index===activeSlideIndex ? 'active':''}`}/>)}
            </div>
            <div className=" grid grid-cols-2  gap-2    py-2 right-0 w-full  px-2 ">

                {activeSlideIndex!==0 && <Button key={activeSlideIndex+'button-prev'} className="text-sm" onClick={handlePrev} theme="link">قبلی</Button>}
                <Button onClick={handleNext} key={activeSlideIndex+'button'} theme="green" rounded="rounded-lg"  className={` text-sm ${activeSlideIndex===0 ? 'col-span-2':'col-span-1'}`}>بعدی</Button>
            </div>
        </div>

    </div>
}
export default AdvanceGuide;